import { organizationUserQueryKeys } from "@/api/query-keys/organizations"
import { getOrganizationUser } from "@/api/services/organizationUser"
import { useAuthStore } from "@/stores/useAuthStore"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useEffect } from "react"

export function useOrganizationUserQuery() {
  const setUser = useAuthStore((state) => state.setUser)

  const query = useSuspenseQuery({
    queryKey: organizationUserQueryKeys.me(),
    queryFn: () => getOrganizationUser(),
    select: (data) => data.data,
  })
  const { data } = query

  useEffect(() => {
    if (data) {
      setUser(data)
    }
  }, [data, setUser])

  return query
}
